import { render, staticRenderFns } from "./UniversityRankingChart.vue?vue&type=template&id=5c4e4602&scoped=true"
import script from "./UniversityRankingChart.vue?vue&type=script&lang=js"
export * from "./UniversityRankingChart.vue?vue&type=script&lang=js"
import style0 from "./UniversityRankingChart.vue?vue&type=style&index=0&id=5c4e4602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4e4602",
  null
  
)

export default component.exports